import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { InfoBarMenuButton } from './InfoBarMenuButton';
import { selectInfoBarState } from '../../store/selectors';
import cn from './InfoBar.css.json';
import './InfoBar.css';
const InfoBarBase = (props) => {
    return props.menuButtonCount === 0 ? null : (_jsx("div", Object.assign({ className: cn.menuButtonContainer }, { children: [...Array(props.menuButtonCount).keys()].map((index) => (_jsx(InfoBarMenuButton, { id: props.id, index: index }, index))) })));
};
export const InfoBar = connect((state, props) => {
    var _a, _b;
    return ({
        menuButtonCount: (_b = (_a = selectInfoBarState(state, props.id).menuButtons) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
    });
})(InfoBarBase);
